import { z } from "zod";

import type { Term } from "domains/language/types";

export const callToActionIdSchema = z.literal("cta-briefing-1");

const callToActionDependenciesSchema = z.object({
  label: z.string(),
  subscription_requirement: z.string().optional(),
  type: z.string(),
  version: z.string(),
});

const callToActionsDestinationsSchema = z.object({
  label: z.custom<Term>((val) => z.string().parse(val)),
  role: z.string(),
  type: z.string(),
  url: z.string(),
});

export const callToActionStorySchema = z.object({
  dependencies: z.array(callToActionDependenciesSchema),
  description: z.string(),
  destinations: z.array(callToActionsDestinationsSchema),
  highlight_element: z.boolean(),
  id: callToActionIdSchema,
  image_url: z.string(),
  images: z.object({
    cover: z.string(),
    inside: z.string(),
  }),
  target_selector: z.string(),
  title: z.string(),
});

export const callToActionResponseSchema = z.object({
  manifest: z.object({
    authoring_hint: z.string(),
    dependencies: z
      .object({
        client: z.string(),
        version: z.string(),
      })
      .array(),
    stories: z.array(callToActionStorySchema),
    valid_from: z.number(),
    version: z.string(),
  }),
});
